"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStartSocket = void 0;
var _reactRedux = require("react-redux");
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _user = require("../../../../entities/user");
var _helpers = require("../../../../utils/helpers");
var _sockets = require("../../../../entities/sockets");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const notAllData = _ref => {
  let {
    socketUrl,
    token,
    logPrefix,
    hideLogs
  } = _ref;
  switch (true) {
    case !socketUrl:
      {
        (0, _helpers.getLog)({
          logPrefix,
          hideLogs,
          text: 'Waiting connecting url'
        });
        return true;
      }
    case !token:
      {
        (0, _helpers.getLog)({
          logPrefix,
          hideLogs,
          text: 'Waiting token'
        });
        return true;
      }
    default:
      return false;
  }
};
const reconnectSocket = _ref2 => {
  let {
    dispatch,
    token,
    socketId,
    socketUrl,
    logPrefix,
    hideLogs
  } = _ref2;
  try {
    (0, _helpers.getLog)({
      logPrefix,
      hideLogs,
      text: 'Reconnection...'
    });
    if (notAllData({
      socketUrl,
      token,
      logPrefix,
      hideLogs
    })) {
      return;
    }
    dispatch((0, _sockets.reconnectSocketAction)({
      socketId,
      socketUrl,
      logPrefix,
      hideLogs
    }));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error.message);
  }
};
const connectSocket = _ref3 => {
  let {
    dispatch,
    token,
    socketId,
    socketUrl,
    logPrefix,
    hideLogs
  } = _ref3;
  try {
    (0, _helpers.getLog)({
      logPrefix,
      hideLogs,
      text: 'Connection...'
    });
    if (notAllData({
      socketUrl,
      token,
      logPrefix,
      hideLogs
    })) {
      return;
    }
    dispatch((0, _sockets.startSocketAction)({
      socketUrl,
      socketId
    }));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error.message);
  }
};
const useStartSocket = _ref4 => {
  let {
    socketUrl,
    mustBeOpen,
    socketId,
    logPrefix,
    hideLogs,
    reconnectCount
  } = _ref4;
  const token = (0, _reactRedux.useSelector)(_user.selectToken);
  const dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(() => {
    const makeStart = () => {
      if (!mustBeOpen) return;
      if (reconnectCount) {
        reconnectSocket({
          dispatch,
          token,
          socketId,
          socketUrl,
          logPrefix,
          hideLogs
        });
        return;
      }
      connectSocket({
        dispatch,
        token,
        socketId,
        socketUrl,
        logPrefix,
        hideLogs
      });
    };
    makeStart();
  }, [dispatch, socketUrl, socketId, token, reconnectCount, logPrefix, hideLogs, mustBeOpen]);
};
exports.useStartSocket = useStartSocket;
useStartSocket.propTypes = {
  socketUrl: _propTypes.default.string,
  mustBeOpen: _propTypes.default.bool.isRequired,
  socketId: _propTypes.default.string.isRequired,
  logPrefix: _propTypes.default.string,
  hideLogs: _propTypes.default.bool
};